import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { Typography } from '../../../constants/Typographies';

export const Wrapper = styled.div`
  margin-top: 30px;
  display: flex;
  border: 4px solid ${Color.PASTEL_GREEN};
  padding: 8px;
`;

export const Label = styled.span`
  ${Typography.L_BOLDER};
  color: ${Color.PASTEL_GREEN};
  margin-right: 8px;
`;
